module.exports = __webpack_public_path__ + "static/media/LogoContact.739461c9.svg";